export default (status) => {
    switch (status) {
        case 'pending_verification':
            return 'pending verification';
        case 'valid':
            return '';
        default:
            return status;
    }
};
